module.exports = __webpack_public_path__ + "static/media/star_F77935.48637835.svg";